<template>
  <div class="page">
    <div class="case-detail__header bg-content">
      <div class="title">
        <img src="/static/imgs/case.png" class="icon" width="28" height="28">
        <span class="text bigger bold name">进件号：
          <template v-if="caseDetail.relationCases && caseDetail.relationCases.length === 1">
            {{caseDetail.relationCases[0].aCaseId}}
          </template>
          <template v-else>
            <el-tooltip effect="dark" :content="caseDetail.caseDetailDTO.aCaseId + (caseDetail.caseDetailDTO.pid === null ? '主案': '子案')" placement="top">
              <el-select placeholder="请选择" v-model="aCaseId" @change="caseChange">
                <template v-for="(item, index) in caseDetail.relationCases">
                  <el-option v-if="item.pid == null && item.caseId == caseDetail.caseDetailDTO.caseId" :key="generator('mainSelect',index)" :value="item.caseId" :label="item.aCaseId+'(主案)'" selected>{{item.aCaseId}}主案</el-option>
                  <el-option v-else-if="item.pid == null && item.caseId != caseDetail.caseDetailDTO.caseId" :key="generator('mainSelect',index)" :value="item.caseId" :label="item.aCaseId+'(主案)'">{{item.aCaseId}}主案</el-option>
                  <el-option v-else-if="item.pid != null && item.caseId == caseDetail.caseDetailDTO.caseId" :key="generator('mainSelect',index)" :value="item.caseId" :label="item.aCaseId+'(子案)'" selected>{{item.aCaseId}}子案</el-option>
                  <el-option v-else-if="item.pid != null && item.caseId != caseDetail.caseDetailDTO.caseId" :key="generator('mainSelect',index)" :value="item.caseId" :label="item.aCaseId+'(子案)'">{{item.aCaseId}}子案</el-option>
                </template>
              </el-select>
            </el-tooltip>
          </template>
        </span>
        <div class="fr">
          <el-dropdown trigger="click" v-if="this.$hasPerm('XQ005') || this.$hasPerm('XQ006') || this.$hasPerm('XQ007') || this.$hasPerm('XQ008') || this.$hasPerm('XQ009')">
            <el-button type="primary" size="small" plain>
              更新<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown" align="right">
              <el-dropdown-item v-if="this.$hasPerm('XQ005')" @click.native="updateVisible = 'updateCaseStatusVisible'">更新状态</el-dropdown-item>
              <el-dropdown-item v-if="this.$hasPerm('XQ006')" @click.native="updateVisible = 'updateContactStatusVisible'">更新联系状态</el-dropdown-item>
              <el-dropdown-item v-if="this.$hasPerm('XQ007')" @click.native="updateVisible = 'updateGroupVisible'">更新策略组</el-dropdown-item>
              <el-dropdown-item v-if="this.$hasPerm('XQ008')" @click.native="updateVisible = 'updateLabelVisible'">更新标签</el-dropdown-item>
              <el-dropdown-item v-if="this.$hasPerm('XQ009')" @click.native="updateVisible = 'promiseVisible'">更新承诺还款时间</el-dropdown-item>
              <el-dropdown-item v-if="this.$hasPerm('XQ011')" @click.native="updateVisible = 'updateAmount'">更新金额</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <el-dropdown trigger="click" v-if="this.$hasPerm('XQ001') || this.$hasPerm('XQ002') || this.$hasPerm('XQ003') || this.$hasPerm('XQ004') || this.$hasPerm('XQ012') || this.$hasPerm('XQ013')">
            <el-button type="primary" size="small">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="this.$hasPerm('XQ001')" @click.native="updateVisible = 'settingVisible'">作业设置</el-dropdown-item>
              <el-dropdown-item v-if="this.$hasPerm('XQ002')" @click.native="updateVisible = 'applyVisible'">申请还款</el-dropdown-item>
              <el-dropdown-item v-if="this.$hasPerm('XQ003')" @click.native="updateVisible = 'addContactVisible'">添加联系人</el-dropdown-item>
              <el-dropdown-item v-if="this.$hasPerm('XQ004')" @click.native="updateVisible = 'commentVisible'">添加评价</el-dropdown-item>
              <el-dropdown-item v-if="this.$hasPerm('XQ012')" @click.native="updateVisible = 'stopVisible'">暂停作业</el-dropdown-item>
              <el-dropdown-item v-if="this.$hasPerm('XQ013')" @click.native="updateVisible = 'continuetVisible'">继续作业</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="info">
        <el-row :gutter="24"  v-if="caseDetail.caseDetailDTO">
          <el-col :span="9">
            <div class="text margin item">
              <label class="label black">批次号：</label>
              <div class="content">{{caseDetail.caseDetailDTO.batchNo}}</div>
            </div>
            <div class="text margin item">
              <label class="label black">最高减免：</label>
              <div class="content">{{caseDetail.caseDetailDTO.planDiscount}}%</div>
            </div>
            <div class="text margin item">
              <label class="label black">策略组：</label>
              <div class="content">{{caseDetail.caseDetailDTO.groupName}}</div>
            </div>
          </el-col>
          <el-col :span="9">
            <div class="text margin item">
              <label class="label black">作业状态：</label>
              <div class="content">
                {{caseDetail.caseDetailDTO.urgeStatus === '0' ? '--' : null}}
                {{caseDetail.caseDetailDTO.urgeStatus === '1' ? '作业中' : null}}
                {{caseDetail.caseDetailDTO.urgeStatus === '-1' ? '暂停作业' : null}}
                {{caseDetail.caseDetailDTO.urgeStatus === '2' ? '作业完成' : null}}
              </div>
            </div>
            <div class="text margin item">
              <label class="label black">已给予减免金额：</label>
              <div class="content">{{caseDetail.caseDetailDTO.deduction}}</div>
            </div>
            <div class="text margin item">
              <label class="label black">作业停止日：</label>
              <div class="content">{{caseDetail.caseDetailDTO.collectionEndDay}}</div>
            </div>
          </el-col>
          <el-col :span="3">
            <p class="text right">案件状态</p>
            <h3 class="text right bigger bold margin black">{{caseDetail.caseDetailDTO.caseStatusDesc}}</h3>
          </el-col>
          <el-col :span="3">
            <p class="text right">AI评分</p>
            <div class="text right margin">
              <span class="text bold bigger primary score" style="font-size: 30px;">{{caseDetail.caseDetailDTO.difficultyScore}}</span> 分
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="page case-detail__content">
      <div class="padding15 bg-content m-b-24">
        <el-tabs v-model="activeTab">
          <el-tab-pane label="客户基本信息" name="customerInfo">
            <el-row :gutter="24" v-if="caseDetail.caseDetailDTO">
              <el-col :span="6">
                <div class="text margin item">
                  <label class="label black">客户姓名：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.name}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">手机号码：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.mobile}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">案件地区：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.address}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">教育程度：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.educateLevel}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">工作年限：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.workingLife}}</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="text margin item">
                  <label class="label black">客户性别：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.gender}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">客户年龄：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.age}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">常住地址：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.permanentAddress}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">入职时间：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.entryDate}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">房产状况：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.house}}</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="text margin item">
                  <label class="label black">身份证号：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.idNo}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">贷款类型：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.loanTypeDesc}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">户籍地址：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.householdRegister}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">婚姻状况：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.maritalStatus}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">子女状况：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.children}}</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="text margin item">
                  <label class="label black">客户所属公司：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.companyBelong}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">作业类型：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.collectTypeDesc}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">公司地址：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.companyAddress}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">职位：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.customerInfo.position}}</div>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="逾期信息" name="overdueInfo">
            <el-row :gutter="24" v-if="caseDetail.caseDetailDTO">
              <el-col :span="6">
                <div class="text margin item">
                  <label class="label black">贷款机构：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.loanInstitutions}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">放款金额：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.loanAmount}}元</div>
                </div>
                <div class="text margin item">
                  <label class="label black">逾期总额：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.overdueAmount}}元</div>
                </div>
                <div class="text margin item">
                  <label class="label black">委托总额：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.delegateAmount}}元</div>
                </div>
                <div class="text margin item">
                  <label class="label black">账单日：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.statementDate}}日</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="text margin item">
                  <label class="label black">放款日期：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.dateOfLoan == null ? null : caseDetail.caseDetailDTO.overdueInfo.dateOfLoan.substring(0,10)}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">月还款额：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.monthlyRepay}}元</div>
                </div>
                <div class="text margin item">
                  <label class="label black">逾期状态：</label>
                  <div class="content">M{{caseDetail.caseDetailDTO.overdueInfo.overdueStatus}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">最近一次还款时间：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.lastRepayDate == null ? null : caseDetail.caseDetailDTO.overdueInfo.lastRepayDate.substring(0,10)}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">借款产品名称：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.loanProductName}}</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="text margin item">
                  <label class="label black">借款期数：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.loanPeriod}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">剩余本金：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.residualPrincipal}}元</div>
                </div>
                <div class="text margin item">
                  <label class="label black">逾期天数：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.overdueDates}}天</div>
                </div>
                <div class="text margin item">
                  <label class="label black">最近一次还款金额：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.lastRepayAmount}}元</div>
                </div>
                <div class="text margin item">
                  <label class="label black">客户绑定划扣银行卡：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.boundBankCard}}</div>
                </div>
              </el-col>
              <el-col :span="6">
                <div class="text margin item">
                  <label class="label black">签约金额：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.amount}}元</div>
                </div>
                <div class="text margin item">
                  <label class="label black">罚滞总额：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.totalPenalty}}元</div>
                </div>
                <div class="text margin item">
                  <label class="label black">逾期次数：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.overdueTime}}</div>
                </div>
                <div class="text margin item">
                  <label class="label black">已还期数：</label>
                  <div class="content">{{caseDetail.caseDetailDTO.overdueInfo.repayedPeriods}}期</div>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="借款公司信息" name="loanInfo" v-if="caseDetail.caseDetailDTO">
            <template v-for="(item,index) in caseDetail.caseDetailDTO.loanCompanyInfoList">
              <el-row :gutter="24" :key="generator('loanInfo',index)">
                <el-col :span="8">
                  <div class="text margin item">
                    <label class="label black">还款银行：</label>
                    <div class="content">{{item.bankName}}</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="text margin item">
                    <label class="label black">还款账号：</label>
                    <div class="content">{{item.cardNumber}}</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="text margin item">
                    <label class="label black">开户人：</label>
                    <div class="content">{{item.bankPeople}}</div>
                  </div>
                </el-col>
              </el-row>
            </template>
          </el-tab-pane>
          <el-tab-pane label="公开信息" name="openInfo">
            <el-row :gutter="24">
              <el-col :span="7">
                <el-row><el-col  align="center">老赖信息</el-col></el-row>
                <el-row style="margin-top: 10px;">
                    <template v-if="renfaDetail == null || renfaDetail.status == 0">
                      <el-table style="width: 100%" :border="true" empty-text="待查询" :data="[]">
                        <el-table-column label="具体情形" align="center" prop="disruptTypeName"/>
                        <el-table-column label="执行法院" align="center" prop="execCourtName"/>
                        <el-table-column label="立案时间" align="center" prop="caseCreateTime"/>
                        <el-table-column label="案号" align="center" prop="caseCode"/>
                        <el-table-column label="内容" align="center" prop="duty"/>
                      </el-table>
                    </template>
                    <template v-else-if="renfaDetail.status == 2" :data="[]">
                      <el-table style="width: 100%" :border="true" empty-text="查询无结果">
                        <el-table-column label="具体情形" align="center" prop="disruptTypeName"/>
                        <el-table-column label="执行法院" align="center" prop="execCourtName"/>
                        <el-table-column label="立案时间" align="center" prop="caseCreateTime"/>
                        <el-table-column label="案号" align="center" prop="caseCode"/>
                        <el-table-column label="内容" align="center" prop="duty"/>
                      </el-table>
                    </template>
                    <template v-else>
                      <el-table style="width: 100%" :border="true" :data="renfaInfo">
                        <el-table-column label="具体情形" align="center" prop="disruptTypeName" :show-overflow-tooltip="true"/>
                        <el-table-column label="执行法院" align="center" prop="execCourtName"/>
                        <el-table-column label="立案时间" align="center" prop="caseCreateTime"/>
                        <el-table-column label="案号" align="center" prop="caseCode"/>
                        <el-table-column label="内容" align="center" prop="duty" :show-overflow-tooltip="true"/>
                      </el-table>
                    </template>
                </el-row>
              </el-col>
              <el-col :span="5">
                <el-row><el-col  align="center">网络标签</el-col></el-row>
                <el-row style="margin-top: 10px;">
                  <el-table :data="caseDetail.phoneLabelByHuiSou" style="width: 100%" :border="true">
                    <el-table-column label="网络标签" align="center">
                      <template slot-scope="scope">
                        {{scope.row}}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-row>
              </el-col>
              <el-col :span="12">
                <el-row><el-col  align="center">房产车产信息</el-col></el-row>
                <el-row style="margin-top: 10px;">
                  <el-table :data="caseDetail.robotHouseCarInfos" style="width: 100%" :border="true">
                    <el-table-column label="标题" align="center">
                      <template slot-scope="scope">
                        <a :href="scope.row.url" target="_blank">{{scope.row.titleInfo}}</a>
                      </template>
                    </el-table-column>
                    <el-table-column prop="belongModule" label="模块" align="center"/>
                    <el-table-column prop="address" label="地址" align="center"/>
                    <el-table-column prop="totalPrice" label="价格" align="center"/>
                    <el-table-column prop="issueTime" label="发布时间" align="center"/>
                  </el-table>
                </el-row>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="还款信息" name="repayInfo">
            <template>
              <el-table :data="caseDetail.robotPayments" style="width: 100%" v-if="caseDetail.robotPayments">
                <el-table-column label="还款人" min-width="100">
                  <template slot-scope="scope">
                    <div v-if="scope.row.payName">{{scope.row.payName}}</div>
                    <div v-else-if="scope.row.recordCreateUser">{{scope.row.recordCreateUser}}</div>
                    <div v-else>--</div>
                  </template>
                </el-table-column>
                <el-table-column prop="payMobile" label="还款人手机号" min-width="150"/>
                <el-table-column prop="payIdNo" label="还款人身份证号" min-width="150"/>
                <el-table-column prop="payCard" label="还款人银行卡号" min-width="150"/>
                <el-table-column prop="repayAmount" label="还款金额(元)" min-width="90"/>
                <el-table-column prop="remitAmount" label="减免金额(元)" min-width="90"/>
                <el-table-column prop="repayTime" label="还款时间" min-width="150"/>
                <el-table-column prop="repayType" label="还款方式" min-width="80"/>
                <el-table-column label="还款凭证" min-width="220">
                  <template slot-scope="scope">
                    <el-popover placement="right" title="还款凭证" width="200px" trigger="click" v-show="scope.row.filePath">
                      <img :src="certificate" alt="" style="width:200px; height: auto;">
                      <el-button type="warning" icon="el-icon-picture" circle slot="reference" @click="getPic(scope.row.filePath)"></el-button>
                    </el-popover>
                    <a :href="scope.row.evidenceUrl" target="_blank" v-if="scope.row.evidenceUrl">电子凭证</a>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-tab-pane>
          <el-tab-pane label="历史变更记录" name="historyInfo">
            <div class="padding15">
                <el-table
                  :data="historyList"
                  size="small"
                  :row-style="{cursor: 'pointer'}"
                  style="width: 100%">
                  <el-table-column
                    prop="time"
                    sortable
                    label="变更时间">
                  </el-table-column>
                  <el-table-column
                    label="变更项目">
                    <template slot-scope="scope">
                      <template v-for="item of scope.row.project">
                        <p v-if="item" :key="item">{{item}}</p>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="原值">
                    <template slot-scope="scope">
                      <template v-for="item of scope.row.oldValue">
                        <p v-if="item != null" :key="item">{{item}}</p>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="新值">
                    <template slot-scope="scope">
                      <template v-for="item of scope.row.newValue">
                        <p v-if="item != null" :key="item">{{item}}</p>
                      </template>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="type"
                    label="方式">
                  </el-table-column>
                  <el-table-column
                    prop="userName"
                    label="操作员"
                    width="120px">
                  </el-table-column>
                </el-table>
                <div class="text center margin15-tb">
                  <el-pagination
                    background
                    layout="prev, pager, next, sizes, total"
                    :total="totalRecords"
                    :page-size="history.limit"
                    :current-page="history.page"
                    @current-change="currentChange"
                    @size-change="sizeChange">
                  </el-pagination>
                </div>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="'共债信息（共'+obligationRes.totalRecords+'笔）'" name="obligationInfo">
            <div class="padding15">
              <el-table
                :data="obligationRes.list"
                size="small"
                :row-style="{cursor: 'pointer'}"
                style="width: 100%">
                <el-table-column label="数据来源">
                  <template slot-scope="scope">
                    <div v-if="scope.row.dataSource === 'rs'">日蚀</div>
                    <div v-else-if="scope.row.dataSource === 'ydm'">云电猫</div>
                    <div v-else>{{scope.row.dataSource}}</div>
                  </template>
                </el-table-column>
                <el-table-column label="逾期金额">
                  <template slot-scope="scope">
                    <div v-if="scope.row.restMoneySum">{{scope.row.restMoneySum}}元</div>
                    <div v-else>-元</div>
                  </template>
                </el-table-column>
                <el-table-column label="减免金额">
                  <template slot-scope="scope">
                    <div v-if="scope.row.remitAmount">{{scope.row.remitAmount}}元</div>
                    <div v-else>-元</div>
                  </template>
                </el-table-column>
                <el-table-column label="逾期天数">
                  <template slot-scope="scope">
                    <div v-if="scope.row.overdueDates">{{scope.row.overdueDates}}天</div>
                    <div v-else>-天</div>
                  </template>
                </el-table-column>
                <el-table-column prop="initTime" label="案件导入日期"/>
              </el-table>
              <div class="text center margin15-tb">
                <el-pagination background layout="prev, pager, next, sizes, total"
                               :total="obligationRes.totalRecords" :page-sizes="[10, 20, 30, 40, 50, 100]"
                               :page-size="obligationReq.limit" :current-page="obligationReq.page"
                               @current-change="obligationPageChange" @size-change="obligationSizeChange"/>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="padding15 bg-content m-b-24">
        <el-tabs v-model="activeTab1">
          <el-tab-pane label="本人" name="self">
            <el-table :data="contactList['benrendianhua']" style="width: 100%" @row-click="getChatRecord">
              <el-table-column prop="contactName" label="联系人姓名" min-width="80"/>
              <el-table-column prop="typeName" label="关系" min-width="70"/>
              <el-table-column prop="relationshipName" label="备注" min-width="50"/>
              <el-table-column label="电话" min-width="120">
                <template slot-scope="scope">
                  {{scope.row.phone.substring(0,3)}}****{{scope.row.phone.substring(7,11)}}
                </template>
              </el-table-column>
              <el-table-column prop="mobileStatus" label="最新电话状态" min-width="100"/>
              <el-table-column prop="status" label="联系状态" min-width="100"/>
              <el-table-column prop="promisePayTime" label="承若还款时间" min-width="150"/>
              <el-table-column prop="label" label="标签" min-width="70"/>
              <el-table-column label="下个作业策略" min-width="350">
                <template slot-scope="scope">
                  <span v-if="caseDetail.caseDetailDTO.urgeStatus === '0'"></span>
                  <span v-else-if="caseDetail.caseDetailDTO.urgeStatus === '-1'">策略停止,作业暂停</span>
                  <span v-else>
                    <span v-if="scope.row.restOfTime === 0">策略停止,案件作业状态未生效</span>
                    <span v-if="scope.row.restOfTime === 1">策略停止,超过作业停止日</span>

                    <span v-if="scope.row.restOfTime === 2">策略停止,当前案件状态为:{{caseDetail.caseDetailDTO.caseStatusDesc}},不发送短信</span>
                    <template v-if="scope.row.restOfTime === 3 && scope.row.restOfTime > 0">
                      <el-tooltip placement="top" effect="light">
                        <div slot="content" v-html="scope.row.content"></div>
                        <interval :time="scope.row.executionTime" :name="scope.row.templateName" :type="scope.row.type === 'msg' ? '短信' : '语音'"></interval>
                      </el-tooltip>
                      <!-- <interval :time="scope.row.executionTime" :name="scope.row.templateName" :type="scope.row.type === 'msg' ? '短信' : '语音'" :content="scope.row.content"></interval> -->
                    </template>
                    <span v-if="scope.row.restOfTime === 4">正在发送{{scope.row.templateName}},{{scope.row.type === 'msg' ? '短信' : '语音'}}</span>
                    <span v-if="scope.row.restOfTime === 5 || scope.row.restOfTime === 6">策略停止,策略执行完成</span>
                    <span v-if="scope.row.restOfTime === 7">策略停止,当前联系人状态为:{{scope.row.status}},不发送短信</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="msgSendCount" label="短信发送数" min-width="80"/>
              <el-table-column prop="ivrSendCount" label="语音发送数" min-width="80"/>
              <el-table-column
                prop="ivrSendCount"
                label="操作"
                min-width="100"
                v-if="this.$account().userName === 'admin'">
                <template slot-scope="scope">
                  <el-button type="primary" icon="el-icon-phone-outline" @click="makecallButton(scope.row)" circle></el-button>
                  <el-button type="danger" icon="el-icon-phone" @click="hangupButton" circle></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="联系人" name="contact">
            <el-table :data="contactList['lianxiren']" style="width: 100%" @row-click="getChatRecord">
              <el-table-column prop="contactName" label="联系人姓名" min-width="80"/>
              <el-table-column prop="typeName" label="关系" min-width="70"/>
              <el-table-column prop="relationshipName" label="备注" min-width="50"/>
              <el-table-column label="电话" min-width="120">
                <template slot-scope="scope">
                  {{scope.row.phone.substring(0,3)}}****{{scope.row.phone.substring(7,11)}}
                </template>
              </el-table-column>
              <el-table-column prop="mobileStatus" label="最新电话状态" min-width="100"/>
              <el-table-column prop="status" label="联系状态" min-width="100"/>
              <el-table-column prop="promisePayTime" label="承若还款时间" min-width="150"/>
              <el-table-column prop="label" label="标签" min-width="70"/>
              <el-table-column label="下个作业策略" min-width="350">
                <template slot-scope="scope">
                  <span v-if="caseDetail.caseDetailDTO.urgeStatus === '0'"></span>
                  <span v-else-if="caseDetail.caseDetailDTO.urgeStatus === '-1'">策略停止,作业暂停</span>
                  <span v-else>
                    <span v-if="scope.row.restOfTime === 0">策略停止,案件作业状态未生效</span>
                    <span v-if="scope.row.restOfTime === 1">策略停止,超过作业停止日</span>

                    <span v-if="scope.row.restOfTime === 2">策略停止,当前案件状态为:{{caseDetail.caseDetailDTO.caseStatusDesc}},不发送短信</span>
                    <template v-if="scope.row.restOfTime === 3 && scope.row.restOfTime > 0">
                      <el-tooltip placement="top" effect="light">
                        <div slot="content" v-html="scope.row.content"></div>
                        <interval :time="scope.row.executionTime" :name="scope.row.templateName" :type="scope.row.type === 'msg' ? '短信' : '语音'"></interval>
                      </el-tooltip>
                      <!-- <interval :time="scope.row.executionTime" :name="scope.row.templateName" :type="scope.row.type === 'msg' ? '短信' : '语音'" :content="scope.row.content"></interval> -->
                    </template>
                    <span v-if="scope.row.restOfTime === 4">正在发送{{scope.row.templateName}},{{scope.row.type === 'msg' ? '短信' : '语音'}}</span>
                    <span v-if="scope.row.restOfTime === 5 || scope.row.restOfTime === 6">策略停止,策略执行完成</span>
                    <span v-if="scope.row.restOfTime === 7">策略停止,当前联系人状态为:{{scope.row.status}},不发送短信</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="msgSendCount" label="短信发送数" min-width="80"/>
              <el-table-column prop="ivrSendCount" label="语音发送数" min-width="80"/>
              <el-table-column
                prop="ivrSendCount"
                label="操作"
                min-width="100"
                v-if="this.$account().userName === 'admin'">
                <template slot-scope="scope">
                  <el-button type="primary" icon="el-icon-phone-outline" @click="makecallButton(scope.row)" circle></el-button>
                  <el-button type="danger" icon="el-icon-phone" @click="hangupButton" circle></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="失联修复" name="repair">
            <el-table :data="contactList['repair']" style="width: 100%" @row-click="getChatRecord">
              <el-table-column prop="contactName" label="联系人姓名" min-width="80"/>
              <el-table-column prop="typeName" label="关系" min-width="70"/>
              <el-table-column prop="relationshipName" label="备注" min-width="50"/>
              <el-table-column label="电话" min-width="120">
                <template slot-scope="scope">
                  {{scope.row.phone.substring(0,3)}}****{{scope.row.phone.substring(7,11)}}
                </template>
              </el-table-column>
              <el-table-column prop="mobileStatus" label="最新电话状态" min-width="100"/>
              <el-table-column prop="status" label="联系状态" min-width="100"/>
              <el-table-column prop="promisePayTime" label="承若还款时间" min-width="150"/>
              <el-table-column prop="label" label="标签" min-width="70"/>
              <el-table-column label="下个作业策略" min-width="350">
                <template slot-scope="scope">
                  <span v-if="caseDetail.caseDetailDTO.urgeStatus === '0'"></span>
                  <span v-else-if="caseDetail.caseDetailDTO.urgeStatus === '-1'">策略停止,作业暂停</span>
                  <span v-else>
                    <span v-if="scope.row.restOfTime === 0">策略停止,案件作业状态未生效</span>
                    <span v-if="scope.row.restOfTime === 1">策略停止,超过作业停止日</span>

                    <span v-if="scope.row.restOfTime === 2">策略停止,当前案件状态为:{{caseDetail.caseDetailDTO.caseStatusDesc}},不发送短信</span>
                    <template v-if="scope.row.restOfTime === 3 && scope.row.restOfTime > 0">
                      <el-tooltip placement="top" effect="light">
                        <div slot="content" v-html="scope.row.content"></div>
                        <interval :time="scope.row.executionTime" :name="scope.row.templateName" :type="scope.row.type === 'msg' ? '短信' : '语音'"></interval>
                      </el-tooltip>
                      <!-- <interval :time="scope.row.executionTime" :name="scope.row.templateName" :type="scope.row.type === 'msg' ? '短信' : '语音'" :content="scope.row.content"></interval> -->
                    </template>
                    <span v-if="scope.row.restOfTime === 4">正在发送{{scope.row.templateName}},{{scope.row.type === 'msg' ? '短信' : '语音'}}</span>
                    <span v-if="scope.row.restOfTime === 5 || scope.row.restOfTime === 6">策略停止,策略执行完成</span>
                    <span v-if="scope.row.restOfTime === 7">策略停止,当前联系人状态为:{{scope.row.status}},不发送短信</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="msgSendCount" label="短信发送数" min-width="80"/>
              <el-table-column prop="ivrSendCount" label="语音发送数" min-width="80"/>
              <el-table-column
                prop="ivrSendCount"
                label="操作"
                min-width="100"
                v-if="this.$account().userName === 'admin'">
                <template slot-scope="scope">
                  <el-button type="primary" icon="el-icon-phone-outline" @click="makecallButton(scope.row)" circle></el-button>
                  <el-button type="danger" icon="el-icon-phone" @click="hangupButton" circle></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="panel">
        <div class="panel-header">
          与{{chatName}}的作业记录
          <el-button
            type="primary"
            plain
            @click="toggleChatMode"
            class="fr"
            :icon="chatMode === 'LIST' ? 'el-icon-message' : 'el-icon-tickets'"
            size="small"
            style="margin-top: -5px;">
            <template v-if="chatMode === 'LIST'">对话模式</template>
            <template v-else>列表模式</template>
          </el-button>
        </div>
        <div class="panel-content">
          <template v-if="chatMode === 'LIST'">
            <el-table
              :data="chatList"
              size="small">
              <el-table-column label="类型" width="140px">
                <template slot-scope="scope">
                  {{scope.row.type}}{{scope.row.sendWay}}
                </template>
              </el-table-column>
              <el-table-column
                label="状态/播放"
                width="300px" style="text-align:center">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.status === '发送成功'" type="success" size="small">{{scope.row.status}}</el-tag>
                  <el-tag v-else-if="scope.row.status === '请求成功'" type="warning" size="small">{{scope.row.status}}</el-tag>
                  <dev v-else-if="scope.row.status === '用户回复'"></dev>
                  <el-tag v-else-if="scope.row.status === '撤销'" type="warning" size="small">{{scope.row.status}}</el-tag>
                  <el-tag v-else-if="scope.row.status === '已发送'" type="warning" size="small">{{scope.row.status}}</el-tag>
                  <el-tag v-else-if="scope.row.status === '发送失败'" type="danger" size="small">{{scope.row.status}}</el-tag>
                  <el-tag v-else-if="scope.row.status === '失败'" type="danger" size="small">{{scope.row.status}}</el-tag>
                  <el-tag v-else-if="scope.row.status === '已呼叫'" type="warning" size="small">{{scope.row.status}}</el-tag>
                  <el-tag v-else-if="scope.row.status === '未触达'" type="danger" size="small">{{scope.row.status}}</el-tag>
                  <el-tag v-else-if="scope.row.status === '已接听' && !scope.row.isIvoice" type="info" size="small">{{scope.row.status}}{{scope.row.answerDuration}}秒</el-tag>
                  <div v-else-if="scope.row.status === '已接听' && scope.row.isIvoice" class="divs">
                    <el-button type="text" v-if="scope.row.showAddress === false" @click="showButton(scope)">录音查看</el-button>
                    <div class="audio" :id="'myAudio'+scope.$index" v-if="scope.row.showAddress === true" v-loading="scope.row.voiceLoading" element-loading-spinner="el-icon-loading"
                      element-loading-background="#F5F7FA" style="height: 30px;width: 180px;outline: none;">
                    </div>
                    <div class="download" v-if="scope.row.showAddress === true">
                      <el-button type="text" v-show="downloadShow === true" @click="download(scope.row.voiceRecordId)">下载</el-button>
                    </div>
                  </div>
                  <div v-else-if="scope.row.status === ''">{{scope.row.status}}</div>
                  <el-tag v-else type="warning" size="small">{{scope.row.status}}</el-tag>

                </template>
              </el-table-column>
              <el-table-column
                prop="content"
                label="内容">
                <template slot-scope="scope">
                  <div v-if="internationalVersionFlag === '1'" :title="languageSelect === '0' ? scope.row.content : scope.row.contentTrans">
                    {{languageSelect === '0' ? scope.row.contentTrans : scope.row.content}}
                  </div>
                  <div v-else>{{scope.row.content}}</div>
                </template>
              </el-table-column>
              <el-table-column
                prop="label"
                label="标签/模板"
                width="180px">
              </el-table-column>
              <el-table-column
                prop="time"
                label="时间"
                width="180px">
              </el-table-column>
            </el-table>
          </template>
          <template v-else>
            <!-- 聊天框 -->
            <div class="chat-wrapper" style="width:70%">
              <!-- <div class="chat-header"><i class="fa fa-comments"></i> 与{{chatName}}的作业记录</div> -->
              <div class="chat-content" style="overflow:scroll">
                <div class="msg-box padding15">
                  <!-- 聊天框内容渲染 -->
                  <template v-for="item of chatList">
                    <!-- 对方 -->
                    <div v-if="item.type === '回复'" class="align-left" :key="item.logId">
                      <div class="item">
                        <div class="label">
                          <img class="avatar" src="/static/imgs/default_avatar.png">
                        </div>
                        <div class="content">
                          <div>
                            <div v-if="internationalVersionFlag === '1'" class="message" :title="languageSelect === '0' ? item.content : item.contentTrans">
                              {{languageSelect === '0' ? item.contentTrans : item.content}}
                            </div>
                            <div v-else class="message">{{item.content}}</div>
                            <p class="time">
                              <span><el-tag type="info" size="mini" :hit="false">{{item.sendWay}}</el-tag></span>
                              <span>{{item.time}}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- 自己 -->
                    <div v-else class="align-right" :key="item.logId">
                      <div class="item">
                        <div class="content">
                          <div>
                            <div v-if="internationalVersionFlag === '1'" class="message" :title="languageSelect === '0' ? item.content : item.contentTrans">
                              {{languageSelect === '0' ? item.contentTrans : item.content}}
                            </div>
                            <div v-else class="message">{{item.content}}</div>
                            <p class="time">
                              <span><el-tag type="info" size="mini" color="#f7f7f7" :hit="false">{{item.sendWay}}</el-tag></span>
                              <span>{{item.time}}</span>
                            </p>
                          </div>
                        </div>
                        <div class="label">
                          <img class="avatar" src="/static/imgs/default_avatar.png">
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="chat-footer" v-if="this.$hasPerm('XQ010')">
                <el-row :gutter="10">
                  <el-col :span="2">
                    <el-button @click="selectMessageTempVisible = true" type="info" icon="el-icon-plus" circle size="small" @click.native="getTemplateList()"></el-button>
                  </el-col>
                  <el-col :span="19">
                    <el-input
                      type="text"
                      size="small"
                      placeholder="请输入内容"
                      v-model="selectTemplate.finalTemplate">
                    </el-input>
                  </el-col>
                  <el-col :span="3">
                    <el-button type="primary" size="small" style="width: 100%;" @click="sendMsg()">发送</el-button>
                  </el-col>
                </el-row>
              </div>
            </div>

            <el-dialog
              v-if="selectMessageTempVisible"
              title="选择模板"
              width="40%"
              :visible.sync="selectMessageTempVisible">
              <el-form size="small" label-width="90px">
                <!--<el-form-item label="模板类型">-->
                  <!--<el-select v-model="template.type" placeholder="请选择" style="width: 100%;">-->
                    <!--<el-option-->
                      <!--v-for="item in options"-->
                      <!--:key="item.value"-->
                      <!--:label="item.label"-->
                      <!--:value="item.value" @click.native="getTemplateList(item.value)"/>-->
                  <!--</el-select>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="模板名称">-->
                  <!--<el-select v-model="template.name" placeholder="请选择" style="width: 100%;">-->
                    <!--<el-option-->
                      <!--v-for="item in showTemplateList"-->
                      <!--:key="item.id"-->
                      <!--:label="item.name"-->
                      <!--:value="item.id">-->
                    <!--</el-option>-->
                  <!--</el-select>-->
                <!--</el-form-item>-->


                <el-row :gutter="24">
                  <el-col :span="24">
                    <el-form-item label="模板类型">
                      <el-select v-model="selectTemplate.currentTemplateType" placeholder="请选择模板类型" style="width: 100%;">
                        <el-option v-for="item in templateList" :key="item.value" :label="item.label" :value="item.value"/>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="24">
                    <el-form-item label="模板名称">
                      <el-select placeholder="请选择模板名称" v-model="selectTemplate.currentTemplateNameType" @change="templateChange" style="width: 100%;" filterable>
                        <el-option v-for="(item , index) in templateTypeSelect()" :key="generator('templateList', index)" :label="item.label" :value="item.value">
                          <el-tooltip placement="top" effect="light">
                            <div slot="content" v-html="item.content"></div>
                            <span>{{item.label}}</span>
                          </el-tooltip>
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>

              </el-form>
              <div slot="footer" class="dialog-footer">
                <!--<el-button type="primary" @click="selectMessageTempVisible = false" size="small">确 定</el-button>-->
                <el-button type="primary" @click="getFinalTemplate();" size="small">确 定</el-button>
              </div>
            </el-dialog>
          </template>
        </div>
        <!-- <el-dialog
          title="电话外呼"
          :visible.sync="phoneCallDialog"
          width="25%">
          <img :src="imgUrl">
        </el-dialog> -->
        <el-dialog title="" :visible.sync="phoneCallDialog" :showClose="false">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-body">
                <div class="col-md-12" style="text-align: center">
                    <img height="200" width="200" src="/static/guns/img/phoneCall.gif"  alt="最小化">
                </div>
                <div class="col-md-12" style="text-align: center">
                  <label>姓名:</label>
                  <a style="color:#111111;text-decoration:none"
                    id="collection_name_layer">{{phoneCall.name}}</a>
                </div>
                <br/><br/><br/>
                <div class="col-md-12" style="text-align: center">
                  <label>电话:</label>
                  <a style="color:#111111;text-decoration:none"
                    id="collection_mobile_view_layer">{{phoneCall.mobile}}</a>
                  <label style="padding-left:20px"></label>
                </div>
                <br/><br/><br/>
                <div id="dialing" style="text-align: center">
                  <label >正在拨号...</label>
                </div>
                <div id="calling" style="display: none;text-align: center">
                  <label>通话中...</label>
                  <label id="timer"></label>
                </div>
                <div id="called" style="display: none;text-align: center">
                  <label>通话已结束...</label>
                  <label id="timer"></label>
                </div>
                <br/><br/>
                <div style="text-align: center" v-if="!hangupButtonShow">
                  <el-input type="textarea" :rows="2" style="width:50%" placeholder="请输入通话备注并提交" v-model="callRemark"></el-input>
                </div>
                <br/><br/>
                <div style="text-align: center" v-if="hangupButtonShow">
                  <a @click="hangupButton">
                    <img height="40" width="40" src="/static/imgs/hangUp.png" style="cursor:pointer;"  alt="挂断">
                  </a>
                </div>
                <div style="text-align: center" v-if="!hangupButtonShow">
                  <el-button type="primary" @click="saveCallDetail" round>保存</el-button>
                </div>
              </div>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>

    <detail-update v-bind:updateVisible="updateVisible"
                    v-bind:contactId="selectTemplate.currentContactId"
                    v-bind:contacts="this.contactList"
                    v-bind:caseDetail="caseDetail"
                    v-on:updateVisible="changeUpdateVisible"/>
    <detail-operate v-bind:updateVisible="updateVisible"
                    v-bind:contactId="selectTemplate.currentContactId"
                    v-bind:contacts="this.contactList"
                    v-bind:caseDetail="caseDetail"
                    v-on:updateVisible="changeUpdateVisible"/>
  </div>
</template>
<script>
import moment from 'moment';
import detailUpdate from './detailUpdate';
import detailOperate from './detailOperate';
import interval from './interval';

const Base64 = require('js-base64').Base64;

export default {
  data() {
    return {
      phoneCallDialog: false,
      hangupButtonShow: true,
      caseDetail: {},
      renfaInfo: [],
      renfaDetail: null,
      contactList: { 'benrendianhua': [], 'lianxiren': [], 'repair': [] },
      // 对话选择模板
      selectTemplate: {
        currentContactId: null,
        currentTemplateId: null,
        currentTemplateType: 'msg',
        currentTemplateName: null,
        finalTemplate: '',
        currentPhone: null,
        currentTemplateNameType: null // 无意义 接收model
      },
      chatList: [],
      templateList: [
        {
          'label': '短信模板',
          'value': 'msg',
          'children': []
        }, {
          'label': '语音模板',
          'value': 'ivr',
          'children': []
        }, {
          'label': '智能语音',
          'value': 'ivoice',
          'children': []
        }
      ],
      chatName: '',
      aCaseId: '',
      activeTab: 'customerInfo',
      activeTab1: 'self',
      chatMode: 'LIST',
      options: [
        {
          value: 'msg',
          label: '短信模板'
        }, {
          value: 'ivr',
          label: '语音模板'
        }
      ],
      template: {
        type: '',
        name: ''
      },
      selectMessageTempVisible: false,
      updateVisible: null,
      // 凭证
      certificate: null,
      historyList: [],
      totalRecords: 0,
      history: {
        page: 1,
        limit: 10
      },
      obligationReq: {
        page: 1,
        limit: 10,
        order: 'createTime',
        sort: 'desc',
        caseId: null
      },
      obligationRes: { totalRecords: 0, list: [] },
      voicePath: 'XXX',
      phoneCall: {
        name: null,
        mobile: null
      },
      callRemark: null,
      downloadShow: true,
      caseId: null,
      catchLanguageSelect: this.$getLanguageSelect()
    };
  },
  mounted() {
    this.login();
    // 将vue中的方法赋值给window
    window.closeCallDialog = this.closeCallDialog;
    // 语言选择监听
    this.langChangeHandler = (newLang) => {
      this.catchLanguageSelect = newLang;
    };
    this.$bus.$on('languageSelectChanged', this.langChangeHandler);
  },
  beforeDestroy() {
    this.$bus.$off('languageSelectChanged', this.langChangeHandler);
  },
  computed: {
    internationalVersionFlag() {
      return this.$getInternationalVersionFlag();
    },
    languageSelect() {
      return this.catchLanguageSelect;
    }
  },
  methods: {
    showButton(scope) {
      scope.row.showAddress = true;
      if (this.$account().companyId === 100000556149675) {
        this.downloadShow = false;
      }
      this.auditionVoice(scope.row, scope.$index);
    },
    // 录音试听
    auditionVoice(row, index) {
      this.$set(row, 'voiceLoading', true);
      this.$downloadVoice({
        url: `/contact/getIntellVoice/${row.voiceRecordId}`,
        method: 'GET',
        responseType: 'blob'
      }).then((re) => {
        const blob = new Blob([re.data]);
        const href = window.URL.createObjectURL(blob);
        const frameAudio = document.createElement('audio');
        frameAudio.controls = true;
        frameAudio.src = href;
        frameAudio.controlsList = 'nodownload';
        frameAudio.style = 'height: 30px;width: 180px;outline: none;';
        const bodyFa = document.getElementById(`myAudio${index}`);
        bodyFa.appendChild(frameAudio);
      }).finally(() => {
        this.$set(row, 'voiceLoading', false);
      });
    },
    // 录音下载
    download(voiceRecordId) {
      this.$downloadVoice({
        method: 'GET',
        url: `/contact/download/${voiceRecordId}`,
        responseType: 'blob'
      }).then((res) => {
        console.warn(res);
        const blob = new Blob([res.data]);
        const fileName = `${Date.parse(new Date())}.wav`;
        if (window.navigator.msSaveOrOpenBlob) {
          // console.log(2)
          navigator.msSaveBlob(blob, fileName);
        } else {
          // console.log(3)
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          // 释放内存
          window.URL.revokeObjectURL(link.href);
        }
      });
    },
    currentChange(page) {
      this.history.page = page;
      this.getHistoryData();
    },
    // 显示条数
    sizeChange(num) {
      this.history.limit = num;
      this.getHistoryData();
    },
    generator(name, index) {
      return `${name}${index}`;
    },
    caseChange(item) {
      const caseId = Base64.decode(this.caseId).trim();
      if (caseId !== item) {
        const encode = Base64.encode(item).trim();
        this.$router.push({ 'path': `/main/case/detail/${encode}` });
        this.$router.go(0);
      }
    },
    toggleChatMode() {
      this.chatMode = this.chatMode === 'LIST' ? 'TALK' : 'LIST';
    },
    changeUpdateVisible(val) {
      this.updateVisible = val;
    },
    login() {
      const companyIdVal = this.$route.params.companyId;
      // const authorization = localStorage.getItem('authorization');
      // if (authorization) {
      //   this.getDetailOpen();
      //   this.getRenfaInfo();
      //   this.getHistoryData();
      //   this.obligationList();
      // } else {
      this.$ajax({
        url: '/account/open-sign-in',
        data: {
          companyId: companyIdVal,
          param: this.$route.params.id
        }
      }).then((res) => {
        localStorage.setItem('authorization', res.data.authorization);
        this.caseId = res.data.caseId;
        this.getDetailOpen();
        this.getRenfaInfo();
        this.getHistoryData();
        this.obligationList();
      });
      // }
    },
    getDetailOpen() {
      const caseId = this.caseId;
      // const companyId = this.$route.params.companyId;
      this.$ajax({
        method: 'GET',
        url: `/caseDetail/gotoCaseDetail/${caseId}`
      }).then((res) => {
        this.caseDetail = res.data;
        if (this.caseDetail.caseDetailDTO.pid == null) {
          this.aCaseId = `${this.caseDetail.caseDetailDTO.aCaseId}(主案)`;
        } else {
          this.aCaseId = `${this.caseDetail.caseDetailDTO.aCaseId}(子案)`;
        }
        if (this.caseDetail.robotRenfaInfoDTO != null) {
          this.renfaInfo.push(this.caseDetail.robotRenfaInfoDTO);
        }
        // 联系人
        this.getContact('benrendianhua', true);
        this.getContact('lianxiren', false);
        this.getContact('repair', false);
      });
    },
    getRenfaInfo() {
      const caseId = this.caseId;
      this.$ajax({
        method: 'GET',
        url: `/caseDetail/deadBeat/${caseId}`
      }).then((res) => {
        this.renfaDetail = res.data;
        if (res.data != null) {
          this.renfaInfo.push(res.data);
        }
      });
    },
    getPic(filePath) {
      this.certificate = null;
      if (filePath) {
        const uri = `/caseDetail/picForAjax?path=${filePath}`;
        this.$ajax({
          method: 'GET',
          url: uri,
          contentType: 'application/json'
        }).then((temp) => {
          this.certificate = `data:image/png;base64,${temp.data}`;
        });
      }
    },
    getContact(type, changeRecord) {
      const caseId = this.caseId;
      const uri = `/contact/getContactDetailInfo/${caseId}/${type}`;
      this.$ajax({
        method: 'GET',
        url: uri
      }).then((res) => {
        res.data.forEach((item) => {
          item.phone = Base64.decode(item.phone).trim();
        });
        this.contactList[type] = res.data;
        if (changeRecord) {
          this.getChatRecord(res.data[0]);
        }
      });
    },
    getChatRecord(row) {
      const phone = Base64.encode(row.phone);
      const contactId = row.contactId;
      const contactName = row.contactName;
      const caseId = Base64.decode(this.caseId).trim();
      const uri = `/contact/getChatRecord/${caseId}/${phone}/${contactId}`;
      const self = this;
      this.$ajax({
        method: 'GET',
        url: uri
      }).then((res) => {
        let data = [];
        if (!self.$hasPerm('XQ014')) {
          res.data.forEach((item) => {
            if (item.sendWay !== '短信') {
              data.push(item);
            }
          });
        } else {
          data = res.data;
        }
        if (self.$hasPerm('XQ015')) {
          data = [];
          res.data.forEach((item) => {
            if (item.status !== '失败' && item.status !== '发送失败') {
              data.push(item);
            }
          });
        }
        self.chatList = data;
        self.chatName = contactName;
        self.selectTemplate.currentContactId = contactId;
        self.selectTemplate.currentPhone = row.phone;
      });
    },
    getTemplateList() {
      this.templateList[0].children = [];
      this.templateList[1].children = [];
      this.templateList[2].children = [];
      const caseId = Base64.decode(this.caseId).trim();
      const uri = `/template/list/${caseId}`;
      this.$ajax({
        method: 'GET',
        url: uri
      }).then((res) => {
        res.data.forEach((item) => {
          item.label = item.name;
          item.value = `${item.id}#${item.name}`;
          if (item.type === 'msg') {
            this.templateList[0].children.push(item);
          } else if (item.type === 'ivr') {
            this.templateList[1].children.push(item);
          } else {
            this.templateList[2].children.push(item);
          }
        });
      });
    },
    getFinalTemplate() {
      const caseId = Base64.decode(this.caseId).trim();
      const uri = `/template/getFinalTemplate/${caseId}/${this.selectTemplate.currentContactId}/${this.selectTemplate.currentTemplateId}`;
      this.$ajax({
        method: 'GET',
        url: uri
      }).then((res) => {
        this.selectTemplate.finalTemplate = res.data;
        this.selectMessageTempVisible = false;
      });
    },
    sendMsg() {
      const uri = '/template/sendMsg';
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: uri,
        contentType: 'application/json',
        data: {
          contactId: this.selectTemplate.currentContactId,
          content: this.selectTemplate.finalTemplate,
          templateId: this.selectTemplate.currentTemplateId,
          type: this.selectTemplate.currentTemplateType
        }
      }).then(() => {
        let temType = '';
        if (this.selectTemplate.currentTemplateType === 'msg') {
          temType = '短信';
        } else if (this.selectTemplate.currentTemplateType === 'ivr') {
          temType = '语音';
        } else {
          temType = '智能语音';
        }
        const data = {
          content: this.selectTemplate.finalTemplate,
          type: temType,
          sendWay: temType,
          status: '发送成功',
          label: this.selectTemplate.currentTemplateName,
          time: moment(Date.now()).format('YYYY-MM-DD HH:mm:ss')
        };
        this.chatList.push(data);
        this.selectTemplate.finalTemplate = null;
        this.selectTemplate.currentTemplateId = null;
        // this.getChatRecord(this.selectTemplate.currentPhone, this.selectTemplate.currentContactId, this.chatName);
      });
    },
    templateChange(item) {
      console.warn(`------${item}`);
      const index = item.indexOf('#');
      const id = item.substring(0, index);
      const name = item.substring(index + 1, item.length);
      console.warn(`------${id}`);
      console.warn(`------${name}`);
      this.selectTemplate.currentTemplateId = id;
      this.selectTemplate.currentTemplateName = name;
    },
    templateTypeSelect() {
      if (this.selectTemplate.currentTemplateType === 'msg') {
        return this.templateList[0].children;
      }
      if (this.selectTemplate.currentTemplateType === 'ivr') {
        return this.templateList[1].children;
      }
      if (this.selectTemplate.currentTemplateType === 'ivoice') {
        return this.templateList[2].children;
      }
      return [];
    },
    // 获取历史记录数据
    getHistoryData() {
      const caseId = Base64.decode(this.caseId).trim();
      this.$ajax({
        url: '/caseDetail/getHistoryList',
        params: { 'caseId': caseId, 'limit': this.history.limit, 'page': this.history.page }
      }).then((res) => {
        this.historyList = res.data.list;
        this.totalRecords = res.data.totalRecords;
      });
    },
    obligationList() {
      const caseId = Base64.decode(this.caseId).trim();
      this.obligationReq.caseId = caseId;
      this.$ajax({
        method: 'GET',
        url: '/caseDetail/obligationCase',
        params: this.obligationReq
      }).then((res) => {
        this.obligationRes = res.data;
      });
    },
    obligationPageChange(page) {
      this.obligationReq.page = page;
      this.obligationList();
    },
    // 显示条数
    obligationSizeChange(num) {
      this.obligationReq.limit = num;
      this.obligationList();
    },
    // 呼叫
    makecallButton(row) {
      const myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;
      if (!myreg.test(row.phone)) {
        this.$message.warning('电话号码不正确！');
        return;
      }
      this.phoneCall.name = row.contactName;
      this.phoneCall.mobile = `${row.phone.substring(0, 3)}****${row.phone.substring(7, 11)}`;
      this.phoneCallDialog = true;
      this.hangupButtonShow = true;
      $('#called').hide();
      $('#calling').hide();
      $('#dialing').show();
      this.$makecallButton(row.phone);
      const callDetail = {
        caseId: Base64.decode(this.caseId).trim(),
        contactId: row.contactId,
        calledNo: row.phone
      };
      sessionStorage.setItem('callDetail', JSON.stringify(callDetail));
    },
    // 挂断
    hangupButton() {
      this.$hangupButton();
    },
    // 关闭电话弹框
    closeCallDialog() {
      this.hangupButtonShow = false;
    },
    saveCallDetail() {
      const callDetail = JSON.parse(sessionStorage.getItem('callDetail'));
      callDetail.remark = this.callRemark;
      this.$ajax({
        method: 'POST',
        url: '/callDetail/saveCallDetail',
        data: callDetail
      }).then((res) => {
        console.warn(res);
        this.phoneCallDialog = false;
      });
    }
  },
  components: {
    detailUpdate, detailOperate, interval
  }
};
</script>
<style lang="less" scoped>
@import '../../../assets/style/variable.less';

.case-detail__header {
  padding: 15px 24px;
  border-bottom: @border;
  .title {
    margin-bottom: 16px;
    .icon {
      margin-right: 12px;
      border-radius: 3px;
      vertical-align: middle;
    }
    .name {
      font-size: 20px;
      vertical-align: middle;
      color: rgba(0, 0, 0, .85);
    }
  }
  .info {
    padding-left: 40px;
    .score {
      line-height: 1;
      font-size: 30px;
      color: #d2a320;
    }
  }
}
.case-detail__content {
  .chat-wrapper {
    width: 800px;
    margin: 20px auto;
    border: @border;
    .chat-header {
      padding: 10px;
      background: #eee;
    }
    .chat-content {
      height: 350px;
      .align-left {
        display: flex;
        justify-content: flex-start;
        .content {
          padding-left: 15px;
          &>div {
            background: #f7f7f7;
          }
        }
      }
      .align-right {
        display: flex;
        justify-content: flex-end;
        .content {
          padding-right: 15px;
          &>div {
            color: #fff;
            background: @primary;
          }
        }
      }
      .item {
        padding: 8px;
        max-width: 550px;
        .label {
          padding-top: 8px;
          .avatar {
            width: 30px;
            height: 30px;
            border-radius: 50%;
          }
        }
        .content {
          .time {
            margin: 5px 0;
            display: flex;
            justify-content: space-between;
            font-size: .86rem;
            font-style: italic;
            &>span:last-child {
              margin-left: 20px;
            }
          }
        }
      }
      .content > div {
        padding: 5px;
        background: #fff;
        border-radius: 5px;
      }
    }
    .chat-footer {
      border-top: @border;
      padding: 10px;
    }
  }
}
.divs .audio,.download{
  display: inline-block;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/page/main/case/openCaseInfo.vue